import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useHeatingCircuit } from '../provider';
import { memo } from 'react';
import * as S from '../styles';
import { formatTemp } from 'utils';
export const OnlyViewHeatingCircuitCard = memo(function OnlyViewHeatingCircuitCard() {
    const { name, current_temperature } = useHeatingCircuit();
    const theme = useTheme();
    return (_jsxs(Box, { children: [_jsx(S.CircuitName, { label: name, fontSize: "1rem", children: name }), _jsx(Typography, { color: "warning.main", children: formatTemp(current_temperature) }), _jsx(Divider, {})] }));
});
